const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const addAllowedIpApi = async (ipData) => {
  const token = localStorage.getItem('token');

  if (!token) {
    console.error('[addAllowedIpApi] Ошибка: Токен авторизации не найден.');
    throw new Error('Токен авторизации не найден.');
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/user/allowed-ips`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(ipData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[addAllowedIpApi] Ошибка при добавлении IP:', errorData);
      

      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('[addAllowedIpApi] Ошибка сети или другая ошибка при добавлении IP:', error);
    throw error;
  }
};